import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export interface IPictureOptions {
    topText?: string;
    bottomText?: string;
}

export default function takePicture(messageBus: SDKMessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('takePicture')) {
        return;
    }

    return (pictureOptions: IPictureOptions = {}): Promise<string> => {
        return messageBus
            .sendRequest<{ picture: string }>(
                'takePicture',
                // don't forget overlay text is top and help text is bottom FOREVER!!! -smathis 2/2019
                Maybe.just(
                    JSON.stringify({
                        overlayText: pictureOptions.topText,
                        helpText: pictureOptions.bottomText
                    })
                )
            )
            .then(response => {
                return response.value.picture;
            });
    };
}
